import { Checkbox, InputNumber, Popover, Space, Typography } from "antd"
import { roundToPrecision } from "../../helpers/math"
import { gold } from "@ant-design/colors"

const { Text } = Typography

type Props = {
  lunch?: number
  defaultLunch: number
  onChange: (lunch: number) => void
  numericOnly?: boolean
  disabled?: boolean
  highlight?: boolean
}

const Lunch = ({ lunch, defaultLunch, onChange, numericOnly, disabled, highlight }: Props) => {
  const hasLunch = !!lunch
  const lunchMinutes = hasLunch ? Math.round(lunch * 60) : 0
  const toHours = (x: number | null) => roundToPrecision((x || 0) / 60, 2)

  const input = <InputNumber min={0} max={120} value={lunchMinutes} onChange={(x) => onChange(toHours(x))} />

  if (numericOnly) {
    return <Space>{input} min</Space>
  }

  const buildDisplayText = () => {
    if (!hasLunch) {
      return <></>
    }

    const innerText = <Text type="secondary" style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>{lunchMinutes} min</Text>
    return disabled ? innerText : <Popover trigger="click" content={input}>{innerText}</Popover>
  }

  return <Space style={{ borderBottom: highlight ? `1px solid ${gold[3]}` : undefined }}>
    <Checkbox checked={hasLunch} disabled={disabled} onChange={(e) =>
      e.target.checked ? onChange(defaultLunch) : onChange(0)
    } />
    {buildDisplayText()}
  </Space>
}
export default Lunch
